var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { useFormContext } from "react-hook-form";
import ValidationService from "../../Services/Shared/Validation.service";
import useUniqueId from "../Hooks/useUniqueId";
import ObjectService from "../../Services/Shared/Object.service";
const TextAreaField = (_a) => {
    var { name, label, required, validate, pattern, min, max, className, disabled, helpText, maxLength, charCounter } = _a, inputProps = __rest(_a, ["name", "label", "required", "validate", "pattern", "min", "max", "className", "disabled", "helpText", "maxLength", "charCounter"]);
    const makeId = useUniqueId()[1];
    const { errors, register } = useFormContext();
    const error = React.useMemo(() => ObjectService.getPropertyAtPath(errors, name), [errors, name]);
    return (_jsxs("div", { className: classNames("form-group", { required }, className), children: [label && _jsx("label", { htmlFor: makeId(name), children: label }), _jsx("textarea", Object.assign({}, inputProps, { id: makeId(name), className: ValidationService.makeClassName(errors, name, "form-control"), name: name, disabled: disabled, maxLength: maxLength, ref: register({
                    required: required ? `${label !== null && label !== void 0 ? label : "This field"} is required` : false,
                    validate,
                    pattern,
                }) })), helpText && _jsx("small", { className: "text-muted", children: helpText }), charCounter, error && _jsx("div", { className: "invalid-feedback", children: error.message })] }));
};
export default TextAreaField;
